import { Icon } from '@iconify/react/dist/iconify.js';
import { CourierInboxPopupMenu, CourierToast, useCourier } from '@trycourier/courier-react'
import { CourierInboxMenuButtonFactoryProps } from '@trycourier/courier-ui-inbox'
import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const renderMenuButton = (props: CourierInboxMenuButtonFactoryProps | null | undefined): ReactNode => {
    const unreadCount = props?.totalUnreadCount ?? 0
    return (
        <button
            style={{
                position: 'relative',
                background: 'var(--mantine-color-gray-2)',
                border: 'none',
                cursor: 'pointer',
                padding: '6px 8px',
                borderRadius: 6,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Icon icon={unreadCount > 0 ? "ph:bell-ringing-duotone" : "ph:bell-duotone"} width={24} color='var(--mantine-color-black)' />
            {unreadCount > 0 && (
                <span style={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    background: 'var(--mantine-color-red-6)',
                    color: '#fff',
                    borderRadius: '50%',
                    fontSize: 10,
                    minWidth: 16,
                    height: 16,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 3px',
                    lineHeight: 1,
                }}>
                    {unreadCount > 99 ? '99+' : unreadCount}
                </span>
            )}
        </button>
    )
}

export const NotificationsButton = () => {
    const courier = useCourier()
    const location = useLocation()
    const navigate = useNavigate()
    return (
        <CourierInboxPopupMenu
            popupAlignment="top-right"
            renderMenuButton={renderMenuButton}
            onMessageActionClick={({ message, action }) => {
                courier.inbox.readMessage(message)
                if (action.href) {
                    navigate(action.href, { state: { drawerFrom: location } })
                }
            }}
            onMessageClick={({ message }) => {
                courier.inbox.readMessage(message)
            }}
        />
    )
}

export const CourierToastComponent = () => {
    const courier = useCourier()
    const location = useLocation()
    const navigate = useNavigate()
    return (
        <CourierToast 
            autoDismiss 
            autoDismissTimeoutMs={5000} 
            onToastItemClick={({ message }) => {
                courier.inbox.readMessage(message)
            }}
            onToastItemActionClick={({ message, action }) => {
                courier.inbox.readMessage(message)
                if (action.href) {
                    navigate(action.href, { state: { drawerFrom: location } })
                }
            }}
        />
    )
}
